import { NavLink } from "react-router-dom";

export default function SectionClients3({ _data }) {
  return (
    <>
      <div className="section-full p-t90 p-b90 site-bg-white tw-client-logo2-area">
        <div className="section-head center wt-small-separator-outer">
          <div className="wt-small-separator site-text-primary">
            <div>{_data.title}</div>
          </div>
        </div>
        <div className="container home-client2-outer">
          <div className="section-content">
            <div className="owl-carousel home-client-carousel2 owl-btn-vertical-center">
              {_data.logos.map((_object, index) => (
                <div key={index} className="item">
                  <div className="ow-client-logo">
                    <div className="client-logo client-logo-media">
                      <NavLink
                        to={_object.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={_object.img} alt="#" />
                      </NavLink>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
